import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import {useTheme} from '../context/ThemeContext';

const data = [
  { name: "Jan", current: 12, previous: 8, amt: 10 },
  { name: "Feb", current: 9, previous: 15, amt: 12 },
  { name: "Mar", current: 11, previous: 13, amt: 14 },
  { name: "Apr", current: 15, previous: 10, amt: 13 },
  { name: "May", current: 18, previous: 12, amt: 16 },
  { name: "Jun", current: 20, previous: 22, amt: 19 },
];


export default function Example() {
    const {theme} = useTheme();
  return (
    <div className='h-[232px] w-[614px]'>
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis dataKey="name" tickLine={false} padding={{ left: 20, right: 20 }} />
        <YAxis axisLine={false} tickLine={false} domain={[0, 30]}
            ticks={[0, 10, 20, 30]}
            tickFormatter={(value) => `${value}M`} />
        <Tooltip />
        <Line type="monotone" dataKey="previous" stroke="#a8c5da" strokeWidth={3} dot={false} />
        <Line type="monotone" dataKey="current" stroke={theme === "#1c1c1c" ? "#c6c7f8" : "#1c1c1c"} strokeWidth={3} dot={false} strokeDasharray="6 6" activeDot={{r:8}} />
      </LineChart>
    </ResponsiveContainer>
    </div>
  );
}
